module.exports = __webpack_public_path__ + "static/media/17.54f6129c.jpg";